import { createContext, useEffect, useReducer } from "react";
import storeReducer, { initialStore } from "./storeReducer";
import { collection, doc, getDoc, increment, onSnapshot, runTransaction, setDoc, updateDoc, writeBatch } from "firebase/firestore";
import { db } from "../../Firebase/firebase";
import swal from "sweetalert";
import { useNavigate } from "react-router";

const StoreContext=createContext()
const StoreProvider = ({children}) => {
const [store, dispatch] = useReducer(storeReducer, initialStore)
const navigate=useNavigate()


useEffect(()=>{
  let unsubscriberPrestamos=()=>{}
  let unsubscriberUsuarios=()=>{}
  let unsubscriberBancas=()=>{}
  const obtieneListeners=async ()=>{
    unsubscriberUsuarios=DatosCollection("usuarios")
    unsubscriberPrestamos=DatosCollection("prestamos")
    unsubscriberBancas=DatosCollection("bancas")
  }
  obtieneListeners()
  return ()=>{
    unsubscriberUsuarios()
    unsubscriberPrestamos()
    unsubscriberBancas()
  }
},[])

  async function dispatchWrite ({type,payload}){
    switch (type) {
      case "nuevoMovimiento":
        var {id,idBanca,obj,callBack}=payload
        await runTransaction(db, async trans=>{
          //Verifica si el archivo existía anteriormente para hacer el ajuste del valor anteriror
          const docMovimiento=await trans.get(doc(db,"bancas",idBanca,"movimientos",id))
          let nuevoValorIncremento=parseFloat(obj.pago||0)
          if (docMovimiento.exists()){
            const objMovimiento=docMovimiento.data()
            nuevoValorIncremento-=parseFloat(objMovimiento.pago)
          }
          trans.update(doc(db,"bancas",idBanca),{totalEntrada:increment(nuevoValorIncremento)})
          trans.set(doc(db,"bancas",idBanca,"movimientos",id),obj)
        }).then(()=>{callBack()}).catch((error)=>{
          console.log(error)
          swal({
              title:"Ocurrió un error",
              text:"Porfavor intenta de nuevo, si el error persiste contacta con el programador"
          })
          callBack()
        })
        return;
      case "agregarBanca":
        var {id,nombre,esBanco,totalEntrada}=payload
        setDoc(doc(db,"bancas",id),{nombre,esBanco,totalEntrada},{merge:true}).then(()=>{
          swal({
            title:"Banca '"+nombre+"' registrada con éxito",
            text:"Lo verás reflejado en el listado de bancas registradas",
            icon:"success"
          })
        }).catch(()=>{
          swal({
            title:"Ocurrió un error",
            text:"Intenta de nuevo, si el error persiste contacta con el programador",
            icon:"error"
          })

        })
        
        return
      case "marcarPrestamoComoTerminado":
        //"marcarPrestamoComoTemrinado",payload:id
        updateDoc(doc(db,"prestamos",payload),{terminado:true, fechaTerminado:new Date().getTime()}).then(()=>{
          swal({
            title:"Prestamo terminado exitosamente",
            icon:"success"
          })
          navigate("/prestamos/concluidos");
        })
        return
      case "marcarPrestamoComoActivo":
        updateDoc(doc(db,"prestamos",payload),{terminado:false, fechaTerminado:""}).then(()=>{
          swal({
            title:"Prestamo activado exitosamente",
            icon:"success"
          })
          navigate("/prestamos/informacion");
        })
        return 
      case "deshabilitarBanca":
        await runTransaction(db, async trans=>{
          const docBanca=await trans.get(doc(db,"bancas",payload))
          if (docBanca.exists()){
            const disabled=!docBanca.data().disabled
            trans.update(doc(db,"bancas",payload),{disabled})
          }
        })
        return
      case "ActualizarIntereses":
        var {keys,idPrestamo,intereses}=payload
        await runTransaction(db, async trans=>{
          const docObj=await trans.get(doc(db,"prestamos",idPrestamo))
          if (docObj.exists()&&Object.keys(docObj.data().historial||{}).length){
            keys.forEach(key=>{
              trans.update(doc(db,"prestamos",idPrestamo),{["historial."+key+".intereses"]:intereses})
            })
          }
        })
        break;
      default:
        break;
    }
  }

  const DatosCollection=(name)=>{
    return onSnapshot(collection(db,name),{ includeMetadataChanges: true },res=>{
      const source = res.metadata.hasPendingWrites ? "Local" : "Server";
      if (source==="Server"){ 
          var formatoObj={}
          res.forEach(item=>{
            formatoObj={...formatoObj,[item.id]:item.data()}
          })
          console.log({[name]:formatoObj})
          dispatch({type:name,payload:formatoObj})
      }
    })
  }

  return (
    <StoreContext.Provider value={[store,dispatch,dispatchWrite]}>
        {children}
    </StoreContext.Provider>
  )
}
export {StoreContext}
export default StoreProvider